import AntdSpace from 'antd/lib/space';
import React     from 'react';

export type SpaceProps = React.ComponentProps<typeof AntdSpace>;
export type SpaceCompactProps = React.ComponentProps<typeof AntdSpace['Compact']>;

const Space = (props: SpaceProps) => {
	return <AntdSpace {...props} />;
};

Space.Compact = (props: SpaceCompactProps) => (
	<AntdSpace.Compact {...props} />
);

export default Space;